import {
	CategoryScale,
	Chart as ChartJS,
	Filler,
	Legend,
	LineElement,
	LinearScale,
	PointElement,
	Title,
	Tooltip
} from 'chart.js';

import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import BaseChart, { CHART_TYPES } from './BaseChart';

ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Title, Tooltip, Filler, Legend);

const options = {
	plugins: {
		legend: {
			display: false
		},

		tooltip: {
			display: true
		}
	},
	scales: {
		y: {
			beginAtZero: true,
			ticks: {},
			grace: 1,
			grid: {
				display: false
			},
			stacked: true
		},
		x: {
			grid: {
				display: false
			}
		}
	},
	interaction: {
		mode: 'nearest',
		axis: 'x',
		intersect: false
	},
	pointRadius: 0,
	datasets: {
		line: {
			tension: 0.5,
			fill: true,
			backgroundColor: ['#ccc']
		}
	}
};

/**
 *
 * @typedef {object} AreaChartProps
 * @property {object} data - The data to display
 * @property {boolean} loading - The loading state
 *
 * data example:
 * {
 * 	labels: ['label1', 'label2'], // the labels should come already translated
 * 	datasets: [
 * 		{
 * 			label: 'nameOfTheDataset', // optional
 * 			data: [10, 20]
 * 		}
 * 	]
 */
const AreaChartV2 = ({ data, loading }) => {
	const { t } = useTranslation();
	const emptyData = useMemo(
		() => ({
			labels: [t('noRecordsFoundTitle')],
			datasets: [
				{
					label: t('noRecordsFoundTitle'),
					data: [1]
				}
			]
		}),
		[]
	);

	const loadingData = useMemo(
		() => ({
			labels: [t('loading')],
			datasets: [
				{
					label: t('loading'),
					data: [1]
				}
			]
		}),
		[]
	);

	const noData = useMemo(() => !data || data.length === 0 || data?.labels?.length === 0, [data]);

	const loadedData = useMemo(() => {
		if (noData) return emptyData;
		return data;
	}, [data, noData, emptyData, loading]);

	return <BaseChart type={CHART_TYPES.line} data={loading ? loadingData : loadedData} options={options} />;
};

export default AreaChartV2;
